import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              精彩视频
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              影评与幕后
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              深度影评、幕后花絮与电影专题视频
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer"
              >
                <div className="relative overflow-hidden h-52">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    title={item.title}
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/30 group-hover:bg-foreground-950/40 transition-colors">
                    <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                      <i className="ri-play-fill text-2xl text-accent-500 ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-foreground-900 font-heading mb-1.5 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500">{item.subtitle}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}